export const OfferCounterStatus = Object.freeze({
  DECLINED: 'declined',
});
